// import { useEffect } from "react";
// import { shallowEqual, useDispatch, useSelector } from "react-redux";
// import { isEmpty } from "lodash";
// store
// import AppStore from "@/app-store";
// import Store from "@/core/reducers/SimpleServiceStore";
// actions
// import ClientMainPageItemsServiceAction from "@/cms/actions/services/ClientMainPageItemsServiceAction";
// types
// import TOdataQueryOptions from "@/core/types/TOdataQueryOptions";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
// enums
// import EContentStatus from "@/cms/enums/EContentStatus";


// request from api
// type TuseMainPageItems = {
//     unqKey:string;
//     mapLayoutName?:string[];
//     filter?:string[]; 
//     removeFromStore?:boolean;
// }

// from header script
type TuseMainPageItems = {
    mapLayoutName:string;
}

// request from api
// const useMainPageItems = ( props:TuseMainPageItems ):TClientMainPageItemList[]|null => {
//     const dispatch = useDispatch();
//     const {unqKey, mapLayoutName, filter = [], removeFromStore=true} = props;

//     const clientMainPageItemsServiceAction = new ClientMainPageItemsServiceAction(dispatch, unqKey);
//     AppStore.reducerManager.add(unqKey, Store(unqKey, clientMainPageItemsServiceAction.serviceCode));
//     const payload = useSelector((state:any) => state?.[unqKey]?.list?.payload, shallowEqual);
//     const webApplicationLanguageCode = useSelector((state:any) => state.CoreStore.language?.payload?.code, shallowEqual);

//     useEffect(() => { _list(); return () => { if (removeFromStore) AppStore.reducerManager.remove(unqKey) } },[]);

//     const _list = () => {
//         const mapLayoutNameFilter = mapLayoutName?.map((item) => `mapLayoutName eq '${item}'`)?.join(" or ")
//         let queryOptions:TOdataQueryOptions = {
//             filter: [`status eq ${EContentStatus.ACTIVE}`, "and", `(${mapLayoutNameFilter})`, ...filter],
//             orderBy: ["order asc"],
//             top: 1000
//         }
//         clientMainPageItemsServiceAction.search({ servicePayload: { queryOptions, language: webApplicationLanguageCode } });
//     }
    
//     if ( !isEmpty(payload) ) return payload;
//     return null;
// }

// from header script
const useMainPageItems = ( props:TuseMainPageItems ):TClientMainPageItemList[]|null => {
    const armadorStaticPayload = document?.getElementById('ARMADORPayload')?.textContent;
    const _armadorStaticPayload = JSON.parse(armadorStaticPayload||"");
    
    return _armadorStaticPayload?.[props.mapLayoutName];
}

export default useMainPageItems;
